import { type RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'

//note: using a dynamic import would cause the sign2.css to be loaded after tenant's own css. Existing customizations are made assuming that tenant's css is loaded after.
// Let's use a static import instead.
// this may only affect the signing view, but to not mix loading styles, import all statically.
// If the issue with tenant custom css is resolved, dynamic imports could be used again.
// The value of dynamic imports is that the files are loaded lazily, so a full page load is faster.

//example of dynamic import in a way that can be somewhat easily converted between static and dynamic:
//const Sign2 = () => import('./components/sign2.vue');
import Info from './components/info.vue';
import LoginTest from './components/logintest.vue';
import Sign2 from './components/sign2.vue';
import CspTest from './components/test.vue';
import Home from './home.vue';
import Accessibility from './components/accessibility.vue';
import Auth from './components/authenticate.vue';
import Logout from './components/logout.vue';
import LoginError from './components/loginerror.vue';

//note: make sure tenantid is the second part of the path, since loading the tenant's custom css depends on this (see main.ts)
const routes: RouteRecordRaw[] = [  
  { path: '/', component: Home },
  { path: '/test', component: CspTest },
  //restrict signatureRequestType to sign|view, otherwise this will catch unintended paths
  { name: 'signview', path: '/:signatureRequestType(sign|view)/:tenantId/:signFlowId/:signatureId', component: Sign2, props: true },
  { name: 'logout-timeout', path: '/sign/:tenantId/:signFlowId/:signatureId/logout/timeout', component: Sign2, props: true },
  { name: 'info', path: '/tietoa/:tenantId', component: Info, props: true },
  { name: 'accessibility', path: '/saavutettavuus/:tenantId', component: Accessibility, props: true },
  { name: 'login-test', path: '/login-test/:schemeid', component: LoginTest, props: true },
  { name: 'login', path: '/login/:tenantId/:signFlowId/:signatureRequestType/:signatureId', component: Auth, props: true },
  { name: 'logout', path: '/logout/:tenantId', component: Logout, props: true },
  { name: 'loginerror', path: '/loginerror', component: LoginError},
  //catch all route
  { path: '/:pathMatch(.*)*', redirect: '/'}
];
const router = createRouter({ 
  history: createWebHistory(), 
  routes: routes,
  
});
router.beforeEach((to, from, next) => {  
  const fromLang = from.query?.lang;
  if(fromLang && !to.query?.lang) {
    to.query.lang= fromLang;
    next(to);
  } else  {
    next();
  }
});

export default router;
